/**
 * LE CSV LISIBLE PAR EXCEL EN FRANÇAIS (écart E124, mis en commun au lot C.4b)
 * =============================================================================
 * Utilisé par l'onglet Évaluation stagiaire (lot 3.6 bis) et l'export de la Certification (CR13).
 * Une seule écriture des trois règles, pour qu'aucun export ne les oublie :
 *   · séparateur « ; » — Excel en français lit la virgule comme décimale et mettrait toute la
 *     ligne dans la colonne A ;
 *   · octet d'ordre UTF-8 (BOM) en tête — sans lui, Excel ouvre en Windows-1252 et « Évaluation »
 *     devient « Ã‰valuation » ;
 *   · échappement des « ; », guillemets et retours à la ligne (vérifié au banc).
 */

/** Une cellule CSV. */
export const cellule = (v) => {
    const s = String(v ?? '');
    return /[;"\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** Le texte du fichier : BOM, « ; », fins de ligne Windows. */
export const texteCsv = (lignes) => '﻿' + lignes.map((l) => l.map(cellule).join(';')).join('\r\n') + '\r\n';

/** Télécharge un CSV (`lignes` : tableau de tableaux, l'en-tête compris). */
export function telechargerCsv(nom, lignes) {
    const url = URL.createObjectURL(new Blob([texteCsv(lignes)], { type: 'text/csv;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url; a.download = nom;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
